import type { IAttributes, IResponse } from '../../types';
import { buildApiUrl } from '../../utils/build-api-url';
import { fetchGet } from '../service';

export async function getAttributes(pimLanguage: string): Promise<IResponse<IAttributes> | null> {
  const url = buildApiUrl('attributes', { pimLanguage });
  return await fetchGet<IAttributes>(url);
}
